import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { constants, compose } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import CommonButton from 'components/buttons/CommonButton/CommonButton'

import Title from '../Title/Title'
import Steps from './Steps/Steps'

import messages from './messages'
import s from './PlanOptions.scss'


class PlanOptions extends Component {

  static propTypes = {
    currPlan: PropTypes.object,
    activeMonthIndex: PropTypes.number,
    onFirstClick: PropTypes.func,
  }

  goNextStep = () => {
    const { goToStep } = this.props

    goToStep(constants.upgradeSubscriptionFlowSteps.selectedPlanSummary)
  }

  render() {
    const { activeMonthIndex, currPlan, selectedPlan, isNoteVisible, onFirstClick } = this.props

    const isOrderButtonVisible = (
      typeof activeMonthIndex === 'number'
      && selectedPlan
      && currPlan.name !== selectedPlan.name
    )

    return (
      <div>
        <Title className={s.title} message={messages.title} />
        {
          isNoteVisible  && (
            <FormattedHTMLMessage className={s.note} tag="div" {...messages.note} />
          )
        }
        <Steps className={s.steps} onFirstClick={onFirstClick} />
        {
          isOrderButtonVisible && (
            <CommonButton
              className={s.orderButton}
              brand
              orderNow
              onClick={this.goNextStep}
              dataTestId={constants.testIds.upgrade.orderButton}
            />
          )
        }
      </div>
    )
  }
}


export default compose(
  connect({
    currPlan: 'models.subscription.currPlan',
    activeMonthIndex: 'models.upgradeSubscriptionFlow.activeMonthIndex',
    isNoteVisible: (state) => {
      const { models: { queue: { items } } } = state

      return items.some(({ status }) => status.includes('free'))
    },
    selectedPlan: actions.models.upgradeSubscriptionFlow.getSelectedPlan,
  }),
)(PlanOptions)
